import { useState, useEffect } from "react"
import 'bootstrap/dist/css/bootstrap.min.css';
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';

const CoinAllocation = () => {
  const { user } = useUser();
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [stocklist, setStocklist] = useState();
  const [allstocking, setAllstocking] = useState([]);
  useEffect(() => {
    fetch(`/stock_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const stockList = Object.values(data);
        const updatedStocks = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        }));
        setStocklist(updatedStocks);
      })
      .catch((err) => console.error("Error loading stock:", err));
  }, [user]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchmyStockes: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedMyStocks = data.mystocks.map(myStock => {
          const stockInfo = stocklist.find(stock => stock.symbol === myStock.symbol);
          return {
            ...myStock,
            price: stockInfo ? stockInfo.price : 0
          };
        });
        console.log(updatedMyStocks);
        setAllstocking(updatedMyStocks);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user, stocklist]);

  return (
    <div className='mt-4'>
      <h5 className='text-center fw-bold mb-2 text-uppercase'>My Stock Holdings</h5>
      <div className="mycard p-2">
        {allstocking.length > 0 ? (
        <div className="table-responsive scrollDown">
          <table className="table table-hover table-striped table-hover table-borderless table-dark align-middle">
            <thead>
              <tr className="fs-7">
                <th>Pair / Holdings</th>
                <th>Purchase Price</th>
                <th>Current Price</th>
                <th>Holdings</th>
                <th>Total Value</th>
                <th>Profit / Loss</th>
              </tr>
            </thead>
            <tbody>
              {allstocking.map((stocking, key) => (
                <tr key={key}>
                  <td>
                      <div className="d-flex align-items-center">
                          <img 
                          src={`https://images.financialmodelingprep.com/symbol/${stocking.symbol}.png`} 
                          alt={stocking.name} 
                          style={{ width: '35px', height: '35px', borderRadius: '50%', marginRight: '8px' }} 
                          />
                          <div className="ms-2">
                              <p className="mb-0 fw-bold">{stocking.name}</p>
                              <p className="mb-0" style={{color:'gray'}}>{stocking.symbol}</p>
                          </div>
                      </div>
                  </td>
                  <td className="text-success fw-bold">{getCurrencySymbol(user?.currency)} {formatCurrency(stocking.pur_price * rate)}</td>
                  <td className="text-success fw-bold">{getCurrencySymbol(user?.currency)} {formatCurrency(stocking.price * rate)}</td>
                  <td>{formatCurrency(stocking.amount / stocking.pur_price)} {stocking.symbol}</td>
                  <td>{getCurrencySymbol(user?.currency)} {formatCurrency(((stocking.amount / stocking.pur_price) * stocking.price) * rate)}</td>
                  <td
                    style={{
                      color:
                        (((stocking.amount / stocking.pur_price) * stocking.price) - stocking.amount) >= 0
                          ? 'green'
                          : 'red'
                    }}
                  >
                    {getCurrencySymbol(user?.currency)}{' '}
                    {formatCurrency(((((stocking.amount / stocking.pur_price) * stocking.price) - stocking.amount) * rate))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        ) : (
        <div className="d-flex align-items-center flex-column justify-content-center w-100 h-100" style={{gap: '16px', color: 'rgba(255, 255, 255, 0.65)'}}>
          <svg style={{width: '40px', height: '40px'}} className="svg-icon" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.132 6.06h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.352 2.5h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V4.7c0-1.76.44-2.2 2.22-2.2Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.132 17.56h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.352 14h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V16.2c0-1.76.44-2.2 2.22-2.2ZM22.132 15.5c0 3.87-3.13 7-7 7l1.05-1.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.05 4.1 3.738 7.414M3.732 4.1l3.314 3.314" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"></path></svg>
          <p className=" mb-0 fw-semibold">No stock holdings.</p>
        </div>
        )}
      </div>
    </div>
  );
};

export default CoinAllocation;